import React from 'react';

interface Props {
  className?: string;
}

const Well: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 180">
      <path
        d="M2 0.5L0 3.5V5.5H2H18H20V3.5L18 0.5H2Z"
        fill="currentColor"
        id="Vector"
      />
      <path
        d="M4 2.5H2V13.5H4V4.5H16V13.5H18V2.5H16H4Z"
        fill="currentColor"
        id="Vector_2"
      />
      <path
        d="M0 14.5V16.5H2V20.5H18V16.5H20V14.5H0Z"
        fill="currentColor"
        id="Vector_3"
      />
      <path
        d="M11.5 10.8781C11.5 11.2759 11.342 11.6575 11.0607 11.9388C10.7794 12.2201 10.3978 12.3781 10 12.3781C9.60217 12.3781 9.22062 12.2201 8.93931 11.9388C8.658 11.6575 8.5 11.2759 8.5 10.8781C8.5 10.0488 10 7.5 10 7.5C10 7.5 11.5 10.0732 11.5 10.8781Z"
        fill="currentColor"
        id="Vector_4"
      />
    </g>
  </svg>
);

export default Well;
